// Shared by every header that can show the "Impersonating X" state
// (TopBanner, DispatcherLayout, DispatcherBoard's own header) -- reading
// localStorage and restoring identity ad hoc in each one is exactly how the
// old bug where stopping impersonation always hard-redirected to /dashboard
// (even from inside /dispatch) happened. One implementation here means it
// can't drift or diverge between consoles again.

export function getImpersonationState() {
  const impersonatedRaw = localStorage.getItem("impersonated_user");
  const realRaw = localStorage.getItem("real_user");
  let impersonatedUser = null;
  let realUser = null;
  try {
    impersonatedUser = impersonatedRaw ? JSON.parse(impersonatedRaw) : null;
    realUser = realRaw ? JSON.parse(realRaw) : null;
  } catch {
    impersonatedUser = null;
    realUser = null;
  }
  return { isImpersonating: !!impersonatedUser, impersonatedUser, realUser };
}

// Restores the real admin/super_admin's own token+identity from
// original_identity (stamped by UserMenu.impersonate at session start),
// clears the impersonation keys, then reloads the CURRENT page -- not a
// hardcoded redirect to /dashboard, so stopping impersonation from within
// /dispatch keeps the caller in /dispatch instead of bouncing them into the
// unrelated generic admin shell.
export function stopImpersonation() {
  const rawOriginal = localStorage.getItem("original_identity");
  try {
    const original = rawOriginal ? JSON.parse(rawOriginal) : null;
    if (original) {
      localStorage.setItem("token", original.token || "");
      localStorage.setItem("roles", original.roles || "[]");
      localStorage.setItem("email", original.email || "");
      localStorage.setItem("id", original.id || "");
      localStorage.setItem("sip_name", original.sip_name || "");
    }
  } catch {
    // fall through -- worst case the stale impersonated identity persists
    // until the next real login, same as the old behavior.
  }

  localStorage.removeItem("original_identity");
  localStorage.removeItem("impersonated_user");
  localStorage.removeItem("real_user");
  // legacy key from before the identity-swap fix -- harmless if absent
  localStorage.removeItem("original_token");

  window.location.reload();
}
